// Non-"use server" so both signup-source.ts (writer) and auth.ts (reader)
// import the same string. Drift here silently breaks signup attribution.

export const SIGNUP_SOURCE_COOKIE = "terac_signup_source";
// Whether the user entered through a researcher or a participant surface. Read
// server-side to pick the landing route for a user who has no organization yet,
// so the name must stay shared with the client writer in signup-intent.ts.
export const SIGNUP_INTENT_COOKIE = "terac_signup_intent";
export const SIGNED_UP_VIA_JOIN_COOKIE = "terac_signed_up_via_join";
export const RECRUITMENT_TOKEN_COOKIE = "terac_recruitment_token";
// Set at a researcher sign-in reached via a business share link (?ref=<token>).
// Distinguishes a business-referral signup from a stale expert /refer signup:
// both write terac_referral_token, so the out-of-process organization.created
// handler needs this marker (persisted to privateMetadata at signup) to know a
// first-org creation should be attributed as a business referral.
export const BUSINESS_REFERRAL_INTENT_COOKIE = "terac_business_referral_intent";
// PostHog browser session id captured at the /join sign-in click so the
// user.create.after hook can attach $session_id to signup_completed and link
// it to the session recording. get_session_id() is client-only, so the client
// writes it here and the server reads it.
export const PH_SESSION_ID_COOKIE = "terac_ph_session_id";
